export const companyInfo = {
  name: "REDENET",
  fullName: "REDENET Comércio Soluções em TI",
  tagline: "Transformando a educação com tecnologia",
  description:
    "A REDENET é uma empresa especializada em desenvolver soluções tecnológicas inovadoras para o setor educacional. Com anos de experiência e uma equipe apaixonada por educação, criamos softwares que conectam escolas, professores, alunos e famílias em uma experiência integrada e moderna.",
  slogan: "Comércio e Soluções em TI",
};

export const products = [
  {
    id: "ie",
    name: "IE",
    subtitle: "Gestão Educacional Integrada",
    description:
      "O IE é a nova versão do iEscolar Online, desenvolvido com tecnologia moderna para atender todas as necessidades de escolas, colégios e redes de ensino. Oferece desde o diário do professor até o portal do responsável, passando por financeiro, matrículas, frequência e muito mais. Chegando em 2027.",
    website: "https://www.iescolaronline.com.br",
    logo: "https://storage.helloreaddy.io/project_files/6df48b80-c75c-4832-be6c-52c7656ae481/05567d2d-cc53-413c-9ec7-e3503bee30c6_compressed_001.webp",
    badge: "Novo em 2027",
    replaces: "iEscolar Online",
    features: [
      "Diário do professor digital",
      "Portal do responsável",
      "Gestão financeira",
      "Matrículas online",
      "Controle de frequência",
      "Relatórios e desempenho",
    ],
  },
  {
    id: "iescolar",
    name: "iEscolar Online",
    subtitle: "Gestão Educacional",
    description:
      "O iEscolar Online é o sistema de gestão educacional atual da REDENET, utilizado por escolas, colégios e redes de ensino em todo o Brasil. Em 2027 será atualizado para a nova versão IE — Gestão Educacional Integrada, trazendo ainda mais recursos e tecnologia.",
    website: "https://www.iescolaronline.com.br",
    logo: "https://storage.helloreaddy.io/project_files/6df48b80-c75c-4832-be6c-52c7656ae481/6dc5db30-492b-4d79-bb1c-d2835d193994_compressed_logo1.webp",
    badge: "Versão Atual",
    features: [
      "Diário do professor",
      "Portal do responsável",
      "Gestão financeira",
      "Matrículas online",
      "Controle de frequência",
      "Relatórios e desempenho",
    ],
  },
  {
    id: "rface",
    name: "RFACE",
    subtitle: "Reconhecimento Facial Inteligente",
    description:
      "O RFACE é um sistema de reconhecimento facial integrado à gestão educacional. O aluno é identificado automaticamente e o sistema envia a frequência diretamente para o diário do professor, além de notificar os pais/responsáveis em tempo real através do aplicativo iEscolar.",
    website: "https://www.rface.com.br",
    logo: "https://storage.helloreaddy.io/project_files/6df48b80-c75c-4832-be6c-52c7656ae481/bb11b7ed-665c-42d2-999f-fe877704b5f5_compressed_rface.webp",
    features: [
      "Identificação facial em tempo real",
      "Integração com diário do professor",
      "Notificações para responsáveis",
      "App de captura de fotos (iOS/Android)",
      "App do responsável (iOS/Android)",
      "Relatórios de frequência automáticos",
    ],
  },
  {
    id: "iluminia",
    name: "iLuminIA",
    subtitle: "Educação Especial com IA",
    description:
      "O iLuminIA é um sistema voltado à educação especial, desenvolvido em parceria com a Universidade Federal do Ceará (UFC). Utiliza inteligência artificial para auxiliar no ensino e acompanhamento de alunos com necessidades especiais.",
    website: "https://www.iluminia.com.br",
    logo: "https://storage.helloreaddy.io/project_files/6df48b80-c75c-4832-be6c-52c7656ae481/7e99760d-c47f-4055-bfa5-1f5c24e33af1_logo_iluminia.svg",
    features: [
      "Inteligência artificial para educação",
      "Foco em educação especial",
      "Parceria UFC",
      "Acompanhamento personalizado",
    ],
  },
  {
    id: "saecta",
    name: "SAECTA",
    subtitle: "Avaliações e Desempenho",
    description:
      "O SAECTA é uma plataforma completa para criação de avaliações e geração de relatórios de desempenho de alunos. Permite criar provas, simulados e acompanhar a evolução dos estudantes ao longo do tempo.",
    website: "https://www.saecta.com.br",
    logo: "",
    features: [
      "Criação de avaliações personalizadas",
      "Relatórios de desempenho",
      "Simulados e provas online",
      "Acompanhamento de evolução",
    ],
  },
];

export const locations = [
  {
    id: "recife",
    city: "Recife",
    state: "PE",
    name: "Porto Digital",
    addressLine1: "Empresarial ITBC – Information Technology Business Center",
    addressLine2:
      "Rua Domingos José Martins, Nº 75, 3º Andar Sala Comercial Nº 307-6",
    neighborhood: "Bairro: Recife Antigo",
    cep: "CEP: 50.030-200",
    phone: "(83) 99846-0015",
  },
  {
    id: "cajazeiras",
    city: "Cajazeiras",
    state: "PB",
    name: "Empresarial Izabel Marques",
    addressLine1: "Rua Odilon Cavalcante, 84, 3° Andar",
    addressLine2: "Salas 302, 303 e 304",
    neighborhood: "Centro",
    cep: "CEP: 58900-00",
    phone: "(83) 99846-0015",
  },
  {
    id: "joao-pessoa",
    city: "João Pessoa",
    state: "PB",
    name: "João Pessoa",
    addressLine1: "Rua Empresário Clovis Rolim, 2051, Andar 23",
    addressLine2: "Sala 2301",
    neighborhood: "Bairro dos Ipês",
    cep: "CEP: 58.028-873",
    phone: "(83) 99846-0015",
  },
  {
    id: "brasilia",
    city: "Brasília",
    state: "DF",
    name: "CR Comercio Residencial",
    addressLine1: "Quadra 502, Bloco C, Loja 37, Parte 3165",
    addressLine2: "Asa Sul",
    neighborhood: "",
    cep: "CEP: 40.000-1407",
    phone: "(61) 3247-1532",
  },
];

export const contacts = {
  emails: [
    { label: "Geral", value: "redenetcomercio@gmail.com" },
    { label: "Comercial", value: "comercial@iescolaronline.com.br" },
    { label: "Suporte", value: "suporte@iescolaronline.com.br" },
  ],
  phones: [
    { label: "Suporte Técnico", value: "(66) 98101-1961", type: "whatsapp" },
    { label: "Comercial", value: "(83) 99846-0015", type: "whatsapp" },
    { label: "Brasília", value: "(61) 3247-1532", type: "phone" },
  ],
};